import { MemberPathSegments } from './member-path-segments';

export class UnauthenticatedRoutes {
  static reviewGolfIndustryHours(): string {
    return `${MemberPathSegments.GolfIndustryHours.golfIndustryHours()}/${MemberPathSegments.GolfIndustryHours.reviewGolfIndustryHoursUnauthenticated()}`;
  }
}
